var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('scroll-container',{attrs:{"height":_vm.height,"minHeight":_vm.minHeight,"maxHeight":_vm.maxHeight,"border":_vm.border,"background":_vm.background,"overflow":_vm.overflow}},[_c('table',{staticClass:"table is-bordered table-fixed"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }